$(function() {
	$('.dropdown').each(function() {
		$(this).on('show.bs.dropdown', function(){
		    TweenLite.to($(this).find('.dropdown-menu').first(), 0, { 
	    		y: 40,
	    		opacity: 0
	    	});
		    TweenLite.to($(this).find('.dropdown-menu').first(), 0.5, { 
	    		display: "block", 
	    		y: 0,
	    		opacity: 1,
	    		ease: Power2.easeInOut, 
	    	});
		});
		$(this).on('hide.bs.dropdown', function(){
			TweenLite.to($(this).find('.dropdown-menu').first(), 0.5, { 
	    		display: "none", 
	    		y: 40,
	    		opacity: 0,
	    		ease: Power2.easeInOut, 
	    	});
		});
	});
});